"use client";

import BannerDeveloper from "./BannerDeveloper";

function DeveloperInfo({ developerData }) {
  return (
    <>
      <BannerDeveloper developerData={developerData} />
    </>
  );
}

export default DeveloperInfo